import React from 'react';
import { ButtonPrimary } from '../../../../../components/ui/Button';
import { LoaderContainer, LoaderEnum, MiniLoader } from '../../../../../ui/Loader/MiniLoader';
import { useTheme } from 'styled-components';
import { useAppSelector } from '../../../../../app/hooks';
import { useTranslation } from 'react-i18next';

interface IProps {
	isDisable: boolean;
	onSend: () => void;
}

export const RegFormSendButton: React.FC<IProps> = ({ isDisable, onSend }) => {
	const Theme = useTheme();
	const { t } = useTranslation();
	const { isPassportChecking } = useAppSelector(state => state.auth);
	return isPassportChecking ? (
		<ButtonPrimary>
			<LoaderContainer>
				<MiniLoader color={Theme.color.primaryBackground} size={LoaderEnum.small} />
			</LoaderContainer>
		</ButtonPrimary>
	) : (
		<ButtonPrimary
			disabled={isDisable}
			onClick={() => {
				onSend();
			}}
		>
			{t('passport.registrationForm.continueButton.name')}
		</ButtonPrimary>
	);
};
